//@ts-check
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.25)'
    }
  };
}, {
  name: 'ECLoadingOverlay'
});

var LoadingOverlay = function LoadingOverlay(props) {
  var classes = useStyles({});
  return React.createElement("div", Object.assign({
    className: classes.root
  }, props));
};

export default LoadingOverlay;